{
  "more": "Більше елементів"
}
